import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import MapFeedDetails from "./routes/MapFeedDetails";

export default store => ({
  path: ":mapType",
  component: withAsyncRouteLoading(() =>
    Promise.all([
      import(/* webpackChunkName: "curriculum-maps" */ "./components"),
    ]).then(([importedModule0]) => {
      const component = importedModule0.default;

      return component;
    })
  ),
  childRoutes: [MapFeedDetails(store)],
});
